"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconRenters = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Renters" }, props),
        react_1.default.createElement("title", null, "Renters"),
        react_1.default.createElement("path", { d: "M65.71 65.673V54.295L8.572 111.434h17.143l39.997-39.996v-5.765z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M54.332 54.295h11.379L8.57 111.434V94.291l39.997-39.996h5.764z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M101.389 18.616c-13.393-13.393-35.1-13.393-48.482 0-13.393 13.393-13.393 35.1 0 48.482 13.393 13.393 35.1 13.393 48.482 0 13.382-13.382 13.382-35.09 0-48.482zM82.854 48.573c-6.311 0-11.433-5.121-11.433-11.432 0-6.31 5.122-11.432 11.433-11.432 6.31 0 11.432 5.132 11.432 11.443 0 6.31-5.122 11.421-11.432 11.421z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M101.389 18.616L90.943 29.063a11.393 11.393 0 013.343 8.078c0 6.31-5.122 11.432-11.432 11.432-3.161 0-6.011-1.275-8.079-3.343L52.896 67.11c13.393 13.393 35.1 13.393 48.483 0 13.392-13.393 13.392-35.1.01-48.493z", fill: "#FF6E00" })));
};
exports.default = BrandIconRenters;
